import { apiFetch, normalizeCursor } from '../../lib/api';

export interface Company {
  company_id: string;
  name: string;
  tax_id?: string;
  country?: string;
  contact?: string;
  status?: string;
  created_at?: number;
  updated_at?: number;
}

export interface CompanyListParams {
  query?: string;
  cursor?: string;
  limit?: number;
}

export interface CompanyListPage {
  companies: Company[];
  nextCursor: string | null;
}

/** Server-side search + opaque cursor browse (restful#72). */
export async function listCompanies(params: CompanyListParams = {}): Promise<CompanyListPage> {
  const res = await apiFetch<{ companies?: Company[]; next_cursor?: string }>('/v3/admin/companies', {
    query: {
      q: params.query || undefined,
      cursor: params.cursor || undefined,
      limit: params.limit,
    },
  });
  return {
    companies: Array.isArray(res.data?.companies) ? res.data.companies : [],
    nextCursor: normalizeCursor(res.data?.next_cursor),
  };
}
